import React, { FunctionComponent } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Formik, Form } from "formik";
import * as yup from "yup";
import { AppState } from "../../store";
import { FormStep } from "./FormSteps/FormStep";
import ServerErrorMessage from "../shared/general/ServerErrorMessage";
import { submitDiversityForm } from "../../actions/diversityFormActions";

export interface IFormComponentProps {
  submitFormAction: typeof submitDiversityForm;
  step: number;
  serverError: boolean;
}

interface IFormValues {
  gender: null | string;
  pronouns: null | string;
  age: null | string;
  ethnicGroup: null | string;
  ethnicSubgroup: null | string;
  disability: null | string;
  orientation: null | string;
  religion: null | string;
  caringResponsibilities: null | string;
  caringResponsibilitiesType: null | string;
  recaptcha: string;
}

const initialValues: IFormValues = {
  gender: null,
  pronouns: null,
  age: null,
  ethnicGroup: null,
  ethnicSubgroup: null,
  disability: null,
  orientation: null,
  religion: null,
  caringResponsibilities: null,
  caringResponsibilitiesType: null,
  recaptcha: "",
};

const validationSchema = yup.object({
  gender: yup
    .string()
    .trim()
    .required("This field is required")
    .min(2, "Minimum of 2 characters")
    .max(50, "Maximum of 50 characters"),
  pronouns: yup
    .string()
    .trim()
    .required("This field is required")
    .min(2, "Minimum of 2 characters")
    .max(50, "Maximum of 50 characters"),
  age: yup.string().trim().required(),
  ethnicGroup: yup.string().trim().required(),
  ethnicSubgroup: yup
    .string()
    .trim()
    .min(2, "Minimum of 2 characters")
    .max(50, "Maximum of 50 characters")
    .nullable(),
  disability: yup.string().trim().required(),
  orientation: yup
    .string()
    .trim()
    .required("This field is required")
    .min(2, "Minimum of 2 characters")
    .max(50, "Maximum of 50 characters"),
  religion: yup
    .string()
    .trim()
    .required("This field is required")
    .min(2, "Minimum of 2 characters")
    .max(50, "Maximum of 50 characters"),
  caringResponsibilities: yup.string().trim().required(),
  caringResponsibilitiesType: yup
    .string()
    .trim()
    .min(2, "Minimum of 2 characters")
    .max(50, "Maximum of 50 characters")
    .nullable(),
  recaptcha: yup.string().nullable().required("This field is required"),
});

export const FormComponent: FunctionComponent<IFormComponentProps> = ({
  submitFormAction,
  step,
  serverError,
}) => (
  <>
    {serverError && <ServerErrorMessage />}
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={() => {
        submitFormAction();
      }}
    >
      {(props) => (
        <Form autoComplete="off">
          <FormStep step={step} {...props} />
        </Form>
      )}
    </Formik>
  </>
);

FormComponent.propTypes = {
  step: PropTypes.number.isRequired,
  serverError: PropTypes.bool.isRequired,
  submitFormAction: PropTypes.func.isRequired,
};

const mapStateToProps = (state: AppState) => ({
  step: state.diversityForm.step,
  serverError: state.diversityForm.serverError,
});

export default connect(mapStateToProps, {
  submitFormAction: submitDiversityForm,
})(FormComponent);
